import { adaptedToEtapeAction, etapeActionToAdapted } from "../../adapter/etapeActionAdapter";
import { adaptedToEtape, etapesToAdapted } from "../../adapter/etapeAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";
import { DELETE_SUCCESS_PARCOURS_CLIENTS } from "./parcoursClientAction";

export const LOAD_SUCCESS_ETAPES = "LOAD_SUCCESS_ETAPES";
export const LOAD_FAIL_ETAPES = "LOAD_FAIL_ETAPES";
export const SAVE_SUCCESS_ETAPES = "SAVE_SUCCESS_ETAPES";
export const SAVE_FAIL_ETAPES = "SAVE_FAIL_ETAPES";
export const UPDATE_SUCCESS_ETAPES = "UPDATE_SUCCESS_ETAPES";
export const UPDATE_FAIL_ETAPES = "UPDATE_FAIL_ETAPES";
export const DELETE_SUCCESS_ETAPES = "DELETE_SUCCESS_ETAPES";
export const DELETE_FAIL_ETAPES = "DELETE_FAIL_ETAPES";

export const SAVE_SUCCESS_ETAPES_ACTIONS = "SAVE_SUCCESS_ETAPES_ACTIONS";
export const SAVE_FAIL_ETAPES_ACTIONS = "SAVE_FAIL_ETAPES_ACTIONS";
export const UPDATE_SUCCESS_ETAPES_ACTIONS = "UPDATE_SUCCESS_ETAPES_ACTIONS";
export const UPDATE_FAIL_ETAPES_ACTIONS = "UPDATE_FAIL_ETAPES_ACTIONS";
export const DELETE_SUCCESS_ETAPES_ACTIONS = "DELETE_SUCCESS_ETAPES_ACTIONS";
export const DELETE_FAIL_ETAPES_ACTIONS = "DELETE_FAIL_ETAPES_ACTIONS";

export function loadEtapes() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapes`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.etape);
          dispatch({
            type: LOAD_SUCCESS_ETAPES,
            payload: etapesToAdapted(res.etape),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_ETAPES,
            error: err,
          });
        });
    });
  };
}

export function saveEtape(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapes`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEtape(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(etapesToAdapted(res.etape));
          dispatch({
            type: LOAD_SUCCESS_ETAPES,
            payload: etapesToAdapted(res.etape),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: SAVE_FAIL_ETAPES,
            error: err,
          });
        });
    });
  };
}

export function updateEtape(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapes/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEtape(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(etapesToAdapted(res.etape));
          dispatch({
            type: LOAD_SUCCESS_ETAPES,
            payload: etapesToAdapted(res.etape),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: UPDATE_FAIL_ETAPES,
            error: err,
          });
        });
    });
  };
}

export function deleteEtape(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapes/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(etapesToAdapted(res.etape));
          dispatch({
            type: LOAD_SUCCESS_ETAPES,
            payload: etapesToAdapted(res.etape),
            id: id,
          });
          dispatch({
            type: DELETE_SUCCESS_PARCOURS_CLIENTS,
            idE: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_ETAPES,
            payload: err,
          });
        });
    });
  };
}

export function saveEtapeAction(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapesActions`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEtapeAction(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(etapeActionToAdapted(res.etape_action));
          dispatch({
            type: SAVE_SUCCESS_ETAPES_ACTIONS,
            payload: etapeActionToAdapted(res.etape_action),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: SAVE_FAIL_ETAPES_ACTIONS,
            error: err,
          });
        });
    });
  };
}

export function updateEtapeAction(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapesActions/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToEtapeAction(jsonData)) })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(etapeActionToAdapted(res.etape_action));
          dispatch({
            type: UPDATE_SUCCESS_ETAPES_ACTIONS,
            payload: etapeActionToAdapted(res.etape_action),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: UPDATE_FAIL_ETAPES_ACTIONS,
            error: err,
          });
        });
    });
  };
}

export function deleteEtapeAction(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`etapesActions/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.etape_action);
          dispatch({
            type: DELETE_SUCCESS_ETAPES_ACTIONS,
            payload: etapeActionToAdapted(res.etape_action),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_ETAPES_ACTIONS,
            payload: err,
          });
        });
    });
  };
}
